// extracted by mini-css-extract-plugin
module.exports = {"selectorContainer":"sold-tos-selector_selectorContainer__2gn39","selectorColumn":"sold-tos-selector_selectorColumn__388WH"};